<template>
    <ul class="list">
        <li
            v-for="store in stores"
            class="listitem">
            <article class="article">
                <header>
                    <h3 class="article-title inline-flex">
                        <img :src="store.storeType.icon" class="mr-2 mt-2">{{ store.name }}</h3>
                </header>

                <span>
                <br>{{ store.address.postalCode }} {{ store.address.city }}, {{
                        store.address.street
                    }} {{ store.address.houseNumber }}
                <br>{{ __('Telefonszám') }}: {{ store.phone }}
                <br>{{ __('E-mail') }}:
                <a :href="'mailto:' + store.email" tabindex="0">{{ store.email }}</a>
                <br><br>{{ __('Nyitva tartás') }}:
                <br>
                <p v-html="store.openingTimes"></p>
            </span>
            </article>
        </li>
    </ul>
</template>

<script>
export default {
    name: 'StoreList',

    props: {
        stores: {
            type: Array
        },
    }
}
</script>

<style scoped>

</style>
